<div class="block">
  <div class="block__topbar">
    <p>Diferencia en el módulo de la rendición</p>
    <qr-button
      *ngIf="this.type == this.TYPE_DELETE"
      class="topbar__btn-close"
      [config]="buttonClose"
      matTooltip="Cerrar"
      (click)="close.emit(true)"
    ></qr-button>
  </div>
  <div class="block__content">
    <p>{{ this.message }}</p>
  </div>
  <div class="block__actions">
    <qr-button
      [config]="buttonRenditions"
      (click)="onRelocation()"
    ></qr-button>
  </div>
</div>
